import { Operation } from "@apollo/client";
import { isFile } from "./isFile";

export function isUpload({ variables }: Operation) {
  return Object.values(variables).some(isFile);
}
